import axios from '@/libs/api.request';

export const financeUserSave = data => {
    return axios.request({
        url: 'api/accountManagement/financeUserManagement/financeUserSave',
        data: data,
        method: 'post'
    });
};

export const getFinanceUserDetail = userFinanceLoginUuid => {
    return axios.request({
        url: 'api/accountManagement/financeUserManagement/getFinanceUserDetail',
        data: { userFinanceLoginUuid },
        method: 'post'
    });
};

export const getFinanceUserList = data => {
    return axios.request({
        url: 'api/accountManagement/financeUserManagement/getFinanceUserList',
        data: data,
        method: 'post'
    });
};
